import { isNotBlank } from '@/shared/utils/is-blank'

const captionClassName = 'live-view__iframe-caption'

export function addIframeCaptions(selector: string = 'iframe[data-description]') {
  document.querySelectorAll<HTMLIFrameElement>(selector).forEach(iframe => {
    if (hasCaption(iframe) === false) {
      const description = iframe.dataset['description']

      if (isNotBlank(description)) {
        const caption = document.createElement('span')

        caption.innerText = description
        caption.classList.add(captionClassName)

        iframe.parentNode?.insertBefore(caption, iframe.nextSibling)
      }
    }
  })
}

function hasCaption(iframe: HTMLIFrameElement) {
  const sibling = iframe.nextElementSibling

  return sibling != null && sibling.classList.contains(captionClassName)
}
